import styles from './DemoBanner.module.css';

const DemoBanner = () => (
  <div className={styles.banner}>
    <span className={styles.text}>Demo Account — View Only</span>
  </div>
);

export default DemoBanner;
